export const COMMON_DEFAULT_HEIGHT = 125;